import { PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { apiClient } from '.';
import { GetPublishedPaymentTemplate } from '@models/paymentTemplate';

export const searchPublishedPaymentTemplates = async (query: SearchPagenateQuery) => {
  return apiClient.get<PagenatedResponse<GetPublishedPaymentTemplate>>('/admin/v1/payment-templates/publish', {
    params: query,
  });
};

export const cancelPublishedPaymentTemplate = async (paymentTemplateId: string) => {
  return apiClient.delete(`/admin/v1/payment-templates/publish/${paymentTemplateId}`);
};
